// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper___Roig","info":"UpdateTermsInfo_info__3yMcg"};